module.exports = __webpack_public_path__ + "img/tbg.c0db8533.png";